var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSh2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    "aria-hidden": "true",
    xmlns: "http://www.w3.org/2000/svg",
    width: 292,
    height: 152.5,
    viewBox: "0 0 292 152.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_38",
    "data-name": "Group 38",
    transform: "translate(-1035.5 -2007)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "revictimization",
    transform: "translate(1181.5 2079)",
    fill: "#4c2750",
    fontSize: 47,
    fontFamily: "Oswald-Bold, Oswald",
    fontWeight: 700,
    letterSpacing: "-0.06em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -145.277,
    y: 0
  }, "REVICTIMIZATION")), /*#__PURE__*/React.createElement("text", {
    id: "Sexual",
    transform: "translate(1182.5 2031)",
    fill: "#1d1d1d",
    fontSize: 20,
    fontFamily: "Oswald-Medium, Oswald",
    fontWeight: 500,
    letterSpacing: "-0.03em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -27.76,
    y: 0
  }, "SEXUAL")), /*#__PURE__*/React.createElement("text", {
    id: "has_been_linked_to_residual_trauma-related_shame_among_child_sexual_abuse_survivors",
    "data-name": "has been linked to residual trauma-related shame among child sexual abuse survivors",
    transform: "translate(1041 2086.5)",
    fill: "#1d1d1d",
    fontSize: 16,
    fontFamily: "Lato-Regular, Lato",
    letterSpacing: "-0.03em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 2.682,
    y: 16
  }, "has been linked to residual trauma-related "), /*#__PURE__*/React.createElement("tspan", {
    x: 1.538,
    y: 36
  }, "shame among child sexual abuse survivors")))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSh2);
export default __webpack_public_path__ + "static/media/sh2.8701145c5cc2436a9c9cf14dda357db1.svg";
export { ForwardRef as ReactComponent };